import React from "react";
import { connect } from "react-redux";
import { compose } from "redux";

import * as setupReducer from "containers/Setup/reducer";
import * as blueprintReducer from "containers/Blueprint/reducer";
import { getStep } from "containers/CreateWizard/reducer";

import RawCosts from "components/CreateWizard/Costs/RawCosts";
import RawCostsContinuous from "components/CreateWizard/Costs/RawCostsContinuous";

class RawCostsContainer extends React.PureComponent {
  render() {
    const { step, isContinuous, index } = this.props;

    return isContinuous ? <RawCostsContinuous {...this.props} /> : <RawCosts {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  updateConversionGain: (conversionGain) => dispatch(setupReducer.updateConversionGain(ownProps.id, conversionGain)),
  updateConversionCost: (conversionCost) => dispatch(setupReducer.updateConversionCost(ownProps.id, conversionCost)),
  updateConversionMissed: (conversionMissed) =>
    dispatch(setupReducer.updateConversionMissed(ownProps.id, conversionMissed)),
  updateConversionSaved: (conversionSaved) =>
    dispatch(setupReducer.updateConversionSaved(ownProps.id, conversionSaved)),
  updateTruePositive: (truePositive) => dispatch(setupReducer.updateTruePositive(ownProps.id, truePositive)),
  updateFalsePositive: (falsePositive) => dispatch(setupReducer.updateFalsePositive(ownProps.id, falsePositive)),
  updateTrueNegative: (trueNegative) => dispatch(setupReducer.updateTrueNegative(ownProps.id, trueNegative)),
  updateFalseNegative: (falseNegative) => dispatch(setupReducer.updateFalseNegative(ownProps.id, falseNegative)),

  updateFalseNegativeLabel: (falseNegativeLabel) =>
    dispatch(setupReducer.updateFalseNegativeLabel(ownProps.id, falseNegativeLabel)),
  updateFalsePositiveLabel: (falsePositiveLabel) =>
    dispatch(setupReducer.updateFalsePositiveLabel(ownProps.id, falsePositiveLabel)),
  updateTrueNegativeLabel: (trueNegativeLabel) =>
    dispatch(setupReducer.updateTrueNegativeLabel(ownProps.id, trueNegativeLabel)),
  updateTruePositiveLabel: (truePositiveLabel) =>
    dispatch(setupReducer.updateTruePositiveLabel(ownProps.id, truePositiveLabel)),
  updateNetImpactLabel: (netImpactLabel) => dispatch(setupReducer.updateNetImpactLabel(ownProps.id, netImpactLabel)),
  updateHideCosts: (hideCosts) => dispatch(setupReducer.updateHideCosts(ownProps.id, hideCosts)),
  updateCustomValue: (id, value) =>
    dispatch(setupReducer.updateCustomValue(ownProps.id, ownProps.blueprintId, id, value)),

  updateIsSimpleCosts: (isSimpleCosts) => dispatch(setupReducer.updateIsSimpleCosts(ownProps.id, isSimpleCosts)),

  updateIsAdvanced: (isAdvanced) => dispatch(blueprintReducer.updateIsAdvanced(ownProps.blueprintId, isAdvanced)),
  updateCustomField: (customField) => dispatch(blueprintReducer.updateCustomField(ownProps.blueprintId, customField)),
  updateCustomFieldById: (id, customField) =>
    dispatch(blueprintReducer.updateCustomFieldById(ownProps.blueprintId, id, customField)),
  updateAdvancedInput: (id, evaluator) =>
    dispatch(blueprintReducer.updateAdvancedInput(ownProps.blueprintId, id, evaluator))
});

const mapStateToProps = (state, ownProps) => {
  const setupBlueprintId = setupReducer.getBlueprintId(state, ownProps.id);

  return {
    conversionGain: setupReducer.getConversionGain(state, ownProps.id),
    conversionCost: setupReducer.getConversionCost(state, ownProps.id),
    conversionMissed: setupReducer.getConversionMissed(state, ownProps.id),
    conversionSaved: setupReducer.getConversionSaved(state, ownProps.id),
    truePositive: setupReducer.getTruePositive(state, ownProps.id),
    falsePositive: setupReducer.getFalsePositive(state, ownProps.id),
    trueNegative: setupReducer.getTrueNegative(state, ownProps.id),
    falseNegative: setupReducer.getFalseNegative(state, ownProps.id),

    truePositiveLabel: setupReducer.getTruePositiveLabel(state, ownProps.id),
    falsePositiveLabel: setupReducer.getFalsePositiveLabel(state, ownProps.id),
    trueNegativeLabel: setupReducer.getTrueNegativeLabel(state, ownProps.id),
    falseNegativeLabel: setupReducer.getFalseNegativeLabel(state, ownProps.id),

    netImpactLabel: setupReducer.getNetImpactLabel(state, ownProps.id),

    currentROI: setupReducer.getCurrentROI(state, ownProps.id),

    hideCosts: setupReducer.getHideCosts(state, ownProps.id),

    outcome: setupReducer.getOutcomeFromDataset(state, ownProps.id),
    success: setupReducer.getSuccessValue(state, ownProps.id),
    successOptions: setupReducer.getSuccessOptions(state, ownProps.id),

    convergeError: setupReducer.getConvergeError(state, ownProps.id),

    isContinuous: setupReducer.getOutcomeType(state, ownProps.id) === "number",
    customValues: setupReducer.getCustomValues(state, ownProps.id),

    isSimpleCosts: setupReducer.getIsSimpleCosts(state, ownProps.id),
    priceColumn: setupReducer.getPriceColumn(state, ownProps.id),

    isAdvanced: blueprintReducer.getIsAdvanced(state, setupBlueprintId ? setupBlueprintId : ownProps.blueprintId),
    customFields:
      ownProps.id === "new"
        ? blueprintReducer.getCustomFields(state, ownProps.blueprintId)
        : blueprintReducer.getCustomFields(state, setupBlueprintId),
    advancedInputs: blueprintReducer.getAdvancedInputs(state, ownProps.blueprintId),

    isEditing: blueprintReducer.getIsEditing(state, ownProps.blueprintId),

    step: getStep(state)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect)(RawCostsContainer);
